import { useNavigate } from 'react-router-dom';
import { t } from '../i18n';

/**
 * "←" left of a page's title (owner request, 2026-10-06): back to the previous page, or to `home`
 * when the page was opened directly.
 */
export function BackButton({ home }: { home: string }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="back-button"
      aria-label={t('common.back')}
      onClick={() => (window.history.length > 1 ? navigate(-1) : navigate(home))}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 5l-7 7 7 7" />
      </svg>
    </button>
  );
}
